import { STAGES } from "@/data/canvas";
import { Check } from "lucide-react";

export function ArchitectureStages() {
  return (
    <div data-testid="architecture-stages" className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
      {STAGES.map((s, i) => {
        const active = s.state === "active";
        return (
          <div
            key={s.n}
            data-testid={`stage-${s.n}`}
            className={`relative rounded-2xl border p-5 ${active ? "border-katlas-blue bg-white shadow-sm" : "border-stone-200 bg-mill-alt/40"}`}
          >
            <div className="flex items-center gap-2">
              <span
                className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-bold ${active ? "bg-katlas-blue text-white" : "bg-stone-200 text-mill-muted"}`}
              >
                {active ? <Check className="h-4 w-4" /> : s.n}
              </span>
              <span className={`text-[11px] font-semibold uppercase tracking-[0.12em] ${active ? "text-katlas-blue" : "text-mill-muted"}`}>
                Stage {s.n}
              </span>
            </div>
            <h4 className="mt-3 font-display text-sm font-semibold text-mill-ink">{s.title}</h4>
            <p className="mt-1 text-xs leading-relaxed text-mill-muted">{s.body}</p>
            {active && (
              <span className="mt-3 inline-block rounded-full bg-[#E8F0EA] px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-mill-moss">
                You are here
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
